<template>
  <div class="app-container">
    <!-- 搜索筛选区域 -->
    <div class="filter-container">
      <el-form :inline="true" :model="listQuery" class="filter-form">
        <el-form-item label="手机号">
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入手机号"
            clearable
            size="small"
            style="width: 160px"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item>
        <el-form-item label="启用状态">
          <el-select
            v-model="listQuery.is_enabled"
            placeholder="请选择"
            clearable
            size="small"
            style="width: 120px"
          >
            <el-option label="启用" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="号码类型">
          <el-select
            v-model="listQuery.phone_type"
            placeholder="请选择"
            clearable
            size="small"
            style="width: 120px"
          >
            <el-option label="真实号码" :value="1" />
            <el-option label="虚拟号码" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="合作商ID">
          <el-input
            v-model="listQuery.app_client_id"
            placeholder="请输入合作商ID"
            clearable
            size="small"
            style="width: 180px"
            type="number"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="handleFilter"
            >查询</el-button
          >
          <el-button size="small" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-toolbar">
      <div class="table-toolbar__primary">
        <el-button type="primary" size="small" @click="handleCreate"
          >新增</el-button
        >
        <el-button type="success" size="small" @click="handleBatchImport"
          >批量导入</el-button
        >
        <el-button type="warning" size="small" @click="handleGenerate"
          >一键生成</el-button
        >
      </div>
      <div class="table-toolbar__batch">
        <span v-if="selectedIds.length" class="selection-summary">
          已选择 {{ selectedIds.length }} 项
        </span>
        <el-button
          type="success"
          size="small"
          :loading="batchLoading"
          :disabled="!selectedIds.length"
          @click="handleBatchEnable"
        >批量启用</el-button>
        <el-button
          type="warning"
          size="small"
          :loading="batchLoading"
          :disabled="!selectedIds.length"
          @click="handleBatchDisable"
        >批量禁用</el-button>
        <el-button
          type="danger"
          size="small"
          :loading="batchLoading"
          :disabled="!selectedIds.length"
          @click="handleBatchDelete"
        >批量删除</el-button>
      </div>
    </div>

    <!-- 表格区域 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      border
      stripe
      size="small"
      element-loading-text="数据加载中"
      empty-text="暂无数据"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="ID" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column
        label="手机号"
        min-width="130"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>
      <el-table-column
        label="合作商"
        min-width="140"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ assignmentOf(scope.row).app_client.name || '无' }}
        </template>
      </el-table-column>
      <el-table-column label="合作商 ID" min-width="120" align="center">
        <template slot-scope="scope">
          {{ assignmentOf(scope.row).app_client_id || '无' }}
        </template>
      </el-table-column>
      <el-table-column label="号码类型" min-width="130" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.phone_type === 1" type="primary" size="small">
            真实号码
          </el-tag>
          <el-tag
            v-else-if="scope.row.phone_type === 2"
            type="warning"
            size="small"
          >
            虚拟号码
          </el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="启用状态" width="100" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.is_enabled"
            :active-value="1"
            :inactive-value="0"
            @click.native="handleStatusClick(scope.row, $event)"
          />
        </template>
      </el-table-column>
      <el-table-column label="累计使用次数" width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.used_count }}
        </template>
      </el-table-column>
      <el-table-column label="最后使用时间" width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.last_used_at || '无' }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
      <el-table-column label="更新时间" width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="action-buttons">
            <el-button
              type="primary"
              size="small"
              @click="handleDetail(scope.row)"
              >查看详情</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="handleUpdate(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="small"
              type="danger"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        :layout="paginationLayout"
        :pager-count="isCompactLayout ? 5 : 7"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 详情弹窗 -->
    <el-dialog
      title="手机号账号池详情"
      :visible.sync="detailDialogVisible"
      width="700px"
      custom-class="phone-pool-dialog"
      :close-on-click-modal="false"
    >
      <div class="detail-content">
        <el-descriptions
          :column="detailDescriptionColumns"
          border
          size="small"
        >
          <el-descriptions-item label="ID">{{
            detailData.id || '无'
          }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{
            detailData.phone || '无'
          }}</el-descriptions-item>
          <el-descriptions-item label="启用状态">
            <el-tag
              v-if="detailData.is_enabled === 1"
              type="success"
              size="small"
              >启用</el-tag
            >
            <el-tag v-else type="info" size="small">禁用</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="累计使用次数">{{
            detailData.used_count || 0
          }}</el-descriptions-item>
          <el-descriptions-item label="最后使用时间">{{
            detailData.last_used_at || '无'
          }}</el-descriptions-item>
          <el-descriptions-item
            label="备注"
            :span="detailDescriptionColumns"
            >{{ detailData.remark || '无' }}</el-descriptions-item
          >
          <el-descriptions-item label="创建时间">{{
            detailData.created_at || '无'
          }}</el-descriptions-item>
          <el-descriptions-item label="更新时间">{{
            detailData.updated_at || '无'
          }}</el-descriptions-item>
        </el-descriptions>

        <!-- 合作商信息 -->
        <div class="assignments-section">
          <h4>合作商信息</h4>
          <el-descriptions
            :column="detailDescriptionColumns"
            border
            size="small"
          >
            <el-descriptions-item label="合作商ID">{{
              assignmentOf(detailData).app_client_id || '无'
            }}</el-descriptions-item>
            <el-descriptions-item label="合作商名称">{{
              assignmentOf(detailData).app_client.name || '无'
            }}</el-descriptions-item>
            <el-descriptions-item label="AppId">{{
              assignmentOf(detailData).app_client.app_id || '无'
            }}</el-descriptions-item>
            <el-descriptions-item label="号码类型">
              <el-tag
                v-if="detailData.phone_type === 1"
                type="success"
                size="small"
                >真实</el-tag
              >
              <el-tag
                v-else-if="detailData.phone_type === 2"
                type="info"
                size="small"
                >虚拟</el-tag
              >
              <el-tag v-else type="info" size="small">无</el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      width="550px"
      custom-class="phone-pool-dialog"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        :label-width="dialogLabelWidth"
        size="small"
        class="form-with-gap"
      >
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="form.phone"
            placeholder="请输入手机号"
            :disabled="isEdit"
            maxlength="20"
            clearable
          />
        </el-form-item>
        <el-form-item label="合作商" prop="app_client_id">
          <el-select
            v-model="form.app_client_id"
            placeholder="请选择合作商"
            clearable
            filterable
            :disabled="isEdit"
            style="width: 100%"
          >
            <el-option
              v-for="item in appClientList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="号码类型" prop="phone_type">
          <el-radio-group v-model="form.phone_type">
            <el-radio :label="1">真实</el-radio>
            <el-radio :label="2">虚拟</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
            maxlength="500"
            clearable
          />
        </el-form-item>
        <el-form-item label="状态" prop="is_enabled">
          <el-radio-group v-model="form.is_enabled">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="handleSubmit"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog
      title="删除确认"
      :visible.sync="deleteDialogVisible"
      width="500px"
      custom-class="phone-pool-dialog phone-pool-dialog--compact"
      :close-on-click-modal="false"
    >
      <div class="delete-tip">
        <p>确定删除该手机号账号？</p>
        <p class="warning-text">
          删除后将解除所有合作商分配关系，该手机号无法再次新建。
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">取消</el-button>
        <el-button type="danger" :loading="deleteLoading" @click="confirmDelete"
          >确认删除</el-button
        >
      </div>
    </el-dialog>

    <!-- 状态切换确认弹窗 -->
    <el-dialog
      :title="statusDialogTitle"
      :visible.sync="statusDialogVisible"
      width="450px"
      custom-class="phone-pool-dialog phone-pool-dialog--compact"
      :close-on-click-modal="false"
    >
      <div class="status-tip">
        <p v-if="targetStatus === 1">
          确定启用该手机号账号？启用后可被订单随机选取。
        </p>
        <p v-else>确定禁用该手机号账号？禁用后不会被订单随机选取。</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelStatusChange">取消</el-button>
        <el-button
          type="primary"
          :loading="statusLoading"
          @click="confirmStatusChange"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 批量导入弹窗 -->
    <PhoneAccountImport
      :visible.sync="importDialogVisible"
      :app-client-list="appClientList"
      @success="getList"
    />

    <!-- 一键生成手机号弹窗 -->
    <el-dialog
      title="一键生成并绑定手机号"
      :visible.sync="generateDialogVisible"
      width="720px"
      custom-class="phone-pool-dialog phone-generate-dialog"
      :close-on-click-modal="false"
      @closed="resetGenerateForm"
    >
      <el-alert
        class="generate-notice"
        title="生成的号码会立即加入手机号池，并自动绑定到所选渠道。系统会跳过已存在及已删除的号码。"
        type="info"
        :closable="false"
        show-icon
      />
      <div class="generate-config-card">
        <div class="generate-section-heading">
          <div class="generate-section-heading__title">基础配置</div>
          <div class="generate-section-heading__description">
            输入固定前缀与数量，系统将随机补齐 11 位并完成渠道绑定
          </div>
        </div>
        <el-form
          ref="generateForm"
          :model="generateForm"
          :rules="generateRules"
          :label-width="dialogLabelWidth"
          size="small"
          class="generate-form"
        >
          <el-form-item label="绑定渠道" prop="app_client_id">
            <el-select
              v-model="generateForm.app_client_id"
              placeholder="请选择合作商/分销渠道"
              filterable
              style="width: 100%"
              @change="generateResult = null"
            >
              <el-option
                v-for="item in appClientList"
                :key="item.id"
                :label="`${item.name}（ID: ${item.id}）`"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="手机号前缀" prop="phone_prefix">
            <el-input
              :value="generateForm.phone_prefix"
              placeholder="例如：1357（1至10位数字，其余位数随机）"
              maxlength="10"
              clearable
              @input="handleGeneratePrefixInput"
            />
          </el-form-item>
          <el-form-item label="生成数量" prop="quantity">
            <el-input-number
              v-model="generateForm.quantity"
              :min="1"
              :max="1000"
              :step="1"
              controls-position="right"
              @change="generateResult = null"
            />
            <span class="generate-help">单次最多生成 1000 个</span>
          </el-form-item>
          <el-form-item label="号码类型" prop="phone_type">
            <el-radio-group v-model="generateForm.phone_type">
              <el-radio :label="1">真实</el-radio>
              <el-radio :label="2">虚拟</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="入池状态" prop="is_enabled">
            <el-radio-group v-model="generateForm.is_enabled">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="generateForm.remark"
              type="textarea"
              :rows="3"
              maxlength="500"
              show-word-limit
              placeholder="选填，用于标记本批号码"
            />
          </el-form-item>
        </el-form>
      </div>

      <div v-if="generatePreviewPhones.length" class="generate-preview">
        <div class="generate-preview__title">生成预览</div>
        <el-descriptions
          :column="detailDescriptionColumns"
          border
          size="small"
        >
          <el-descriptions-item label="绑定渠道">
            {{ selectedGenerateAppClientName }}
          </el-descriptions-item>
          <el-descriptions-item label="预计生成">
            {{ generateForm.quantity }} 个
          </el-descriptions-item>
          <el-descriptions-item
            label="号码示例"
            :span="detailDescriptionColumns"
          >
            <el-tag
              v-for="phone in generatePreviewPhones"
              :key="phone"
              size="small"
              class="generate-phone-tag"
            >{{ phone }}</el-tag>
            <span class="generate-help">示例仅展示格式，实际后缀随机生成并跳过已占用号码</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <div v-if="generateResult" class="generate-result">
        <el-alert
          :title="`已成功生成并绑定 ${generateResult.generated_count} 个手机号`"
          type="success"
          :closable="false"
          show-icon
        />
        <el-table
          :data="paginatedGenerateItems"
          border
          stripe
          size="small"
          max-height="260"
          class="generate-result-table"
        >
          <el-table-column type="index" label="#" width="60" align="center" />
          <el-table-column prop="phone" label="已生成手机号" align="center" />
          <el-table-column label="绑定渠道" align="center">
            <template>{{ selectedGenerateAppClientName }}</template>
          </el-table-column>
        </el-table>
        <div
          v-if="generateResultTotal > generateResultPageSize"
          class="dialog-pagination"
        >
          <el-pagination
            :current-page="generateResultPage"
            :page-size="generateResultPageSize"
            :total="generateResultTotal"
            :pager-count="isCompactLayout ? 5 : 7"
            background
            layout="total, prev, pager, next"
            @current-change="generateResultPage = $event"
          />
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="generateDialogVisible = false">关闭</el-button>
        <el-button
          type="primary"
          :loading="generateLoading"
          @click="submitGenerate"
        >生成并绑定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import PhoneAccountImport from './PhoneAccountImport'

export default {
  name: 'PhoneAccountPool',
  components: {
    PhoneAccountImport,
  },
  data() {
    return {
      // 列表数据
      list: null,
      total: 0,
      listLoading: true,
      // 查询参数
      listQuery: {
        page: 1,
        limit: 10,
        phone: undefined,
        is_enabled: undefined,
        app_client_id: undefined,
      },
      // 详情弹窗
      detailDialogVisible: false,
      detailData: {},
      // 新增/编辑弹窗
      dialogFormVisible: false,
      dialogTitle: '',
      btnLoading: false,
      isEdit: false,
      form: {
        id: null,
        phone: '',
        app_client_id: undefined,
        phone_type: 2,
        remark: '',
        is_enabled: 1,
      },
      // 删除确认弹窗
      deleteDialogVisible: false,
      deleteLoading: false,
      deleteId: null,
      // 状态切换确认弹窗
      statusDialogVisible: false,
      statusDialogTitle: '',
      statusLoading: false,
      statusId: null,
      targetStatus: null,
      // 合作商列表（用于下拉选择）
      appClientList: [],
      // 批量导入弹窗
      importDialogVisible: false,
      // 一键生成并绑定
      generateDialogVisible: false,
      generateLoading: false,
      generateResult: null,
      generateResultPage: 1,
      generateResultPageSize: 20,
      viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1280,
      generateForm: {
        app_client_id: undefined,
        phone_prefix: '',
        quantity: 10,
        phone_type: 2,
        is_enabled: 1,
        remark: '',
      },
      generateRules: {
        app_client_id: [
          { required: true, message: '请选择绑定渠道', trigger: 'change' },
        ],
        phone_prefix: [
          { required: true, message: '请输入手机号前缀', trigger: 'blur' },
          {
            pattern: /^\d{1,10}$/,
            message: '请输入1至10位数字',
            trigger: 'blur',
          },
        ],
        quantity: [
          { required: true, message: '请输入生成数量', trigger: 'change' },
          { type: 'number', min: 1, max: 1000, message: '生成数量应为1至1000', trigger: 'change' },
        ],
      },
      // 批量操作
      selectedIds: [],
      batchLoading: false,
      // 表单校验规则
      rules: {
        phone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的手机号格式',
            trigger: 'blur',
          },
        ],
        app_client_id: [
          { required: true, message: '请选择合作商', trigger: 'change' },
        ],
        phone_type: [
          { required: true, message: '请选择号码类型', trigger: 'change' },
        ],
        remark: [{ max: 500, message: '最大长度为500个字符', trigger: 'blur' }],
        is_enabled: [
          { required: true, message: '请选择状态', trigger: 'change' },
        ],
      },
    }
  },
  created() {
    this.getList()
    this.getAppClientList()
  },
  mounted() {
    window.addEventListener('resize', this.updateViewportWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewportWidth)
  },
  computed: {
    isCompactLayout() {
      return this.viewportWidth <= 768
    },
    paginationLayout() {
      return this.isCompactLayout
        ? 'total, prev, pager, next'
        : 'total, sizes, prev, pager, next, jumper'
    },
    detailDescriptionColumns() {
      return this.isCompactLayout ? 1 : 2
    },
    dialogLabelWidth() {
      return this.isCompactLayout ? '88px' : '120px'
    },
    selectedGenerateAppClientName() {
      const selected = this.appClientList.find(
        (item) => item.id === this.generateForm.app_client_id,
      )
      return selected ? `${selected.name}（ID: ${selected.id}）` : '未选择'
    },
    generatePreviewPhones() {
      const prefix = this.generateForm.phone_prefix
      if (!/^\d{1,10}$/.test(prefix)) return []
      const suffixLength = 11 - prefix.length
      const count = Math.min(Number(this.generateForm.quantity) || 0, 3)
      const sampleSuffixes = ['5830471926', '2749168053', '8613504279']
      return Array.from({ length: count }, (_, index) =>
        prefix + sampleSuffixes[index].slice(0, suffixLength),
      )
    },
    generateResultTotal() {
      return this.generateResult && Array.isArray(this.generateResult.items)
        ? this.generateResult.items.length
        : 0
    },
    paginatedGenerateItems() {
      if (!this.generateResultTotal) return []
      const start = (this.generateResultPage - 1) * this.generateResultPageSize
      return this.generateResult.items.slice(
        start,
        start + this.generateResultPageSize,
      )
    },
  },
  methods: {
    updateViewportWidth() {
      this.viewportWidth = window.innerWidth
    },

    assignmentOf(phoneAccount) {
      const assignments = (phoneAccount && phoneAccount.assignments) || []
      const assignment = assignments[0]
      if (!assignment) return { app_client: {} }
      if (!assignment.app_client) {
        return { app_client_id: assignment.app_client_id, app_client: {} }
      }
      return assignment
    },

    /**
     * 获取列表数据
     */
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/phone-account-pool/list',
        method: 'get',
        params: this.listQuery,
      })
        .then((response) => {
          console.log(response)

          this.list = response.data.data || []
          this.total = response.data.total || 0
        })
        .catch((error) => {
          console.error('获取列表失败:', error)
          this.$message.error('获取列表失败')
        })
        .finally(() => {
          this.listLoading = false
        })
    },

    /**
     * 搜索查询
     */
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },

    /**
     * 重置筛选条件
     */
    handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10,
        phone: undefined,
        is_enabled: undefined,
        app_client_id: undefined,
      }
      this.getList()
    },

    /**
     * 页大小变化
     */
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.listQuery.page = 1
      this.getList()
    },

    /**
     * 页码变化
     */
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },

    /**
     * 查看详情
     */
    handleDetail(row) {
      console.log(row)

      this.detailData = row
      this.detailDialogVisible = true
    },

    /**
     * 新增
     */
    handleCreate() {
      this.dialogTitle = '新增手机号账号'
      this.isEdit = false
      this.form = {
        id: null,
        phone: '',
        app_client_id: undefined,
        phone_type: 2,
        remark: '',
        is_enabled: 1,
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
      this.dialogFormVisible = true
    },

    /**
     * 编辑
     */
    handleUpdate(row) {
      this.dialogTitle = '编辑手机号账号'
      this.isEdit = true
      this.form = {
        id: row.id,
        phone: row.phone,
        app_client_id: row.assignments?.[0]?.app_client_id,
        phone_type: row.phone_type || 2,
        remark: row.remark || '',
        is_enabled: row.is_enabled,
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
      this.dialogFormVisible = true
    },

    /**
     * 提交保存
     */
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.btnLoading = true

          // 构建请求数据
          const data = { ...this.form }
          // 新增时不传id
          if (!this.form.id) {
            delete data.id
          }

          request({
            url: '/api/backend/phone-account-pool/store',
            method: 'post',
            data: data,
          })
            .then(() => {
              this.$message.success('保存成功')
              this.dialogFormVisible = false
              this.getList()
            })
            .catch((error) => {
              console.error('保存失败:', error)
              this.$message.error('保存失败')
            })
            .finally(() => {
              this.btnLoading = false
            })
        }
      })
    },

    /**
     * 关闭弹窗
     */
    handleClose() {
      this.dialogFormVisible = false
      this.$refs.form && this.$refs.form.resetFields()
    },

    /**
     * 删除操作 - 打开确认弹窗
     */
    handleDelete(row) {
      this.deleteId = row.id
      this.deleteDialogVisible = true
    },

    /**
     * 确认删除
     */
    confirmDelete() {
      if (!this.deleteId) return

      this.deleteLoading = true

      request({
        url: '/api/backend/phone-account-pool/delete',
        method: 'post',
        data: {
          id: this.deleteId,
        },
      })
        .then(() => {
          this.$message.success('删除成功')
          this.deleteDialogVisible = false
          this.getList()
        })
        .catch((error) => {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        })
        .finally(() => {
          this.deleteLoading = false
        })
    },

    /**
     * 状态切换 - 打开确认弹窗
     */
    handleStatusClick(row, event) {
      // 阻止默认切换
      event.preventDefault()
      event.stopPropagation()
      // 点击后 row.is_enabled 已变为目标状态
      this.targetStatus = row.is_enabled
      this.statusId = row.id
      this.statusDialogTitle = this.targetStatus === 0 ? '禁用确认' : '启用确认'
      this.statusDialogVisible = true
    },

    /**
     * 取消状态切换
     */
    cancelStatusChange() {
      // 由于已阻止默认切换，状态未改变，无需手动恢复
      this.statusDialogVisible = false
    },

    /**
     * 确认状态切换
     */
    confirmStatusChange() {
      if (!this.statusId) return

      this.statusLoading = true

      request({
        url: '/api/backend/phone-account-pool/change-status',
        method: 'post',
        data: {
          id: this.statusId,
          is_enabled: this.targetStatus,
        },
      })
        .then(() => {
          this.$message.success('状态更新成功')
          // 更新列表中的状态
          const row = this.list.find((item) => item.id === this.statusId)
          if (row) {
            row.is_enabled = this.targetStatus
          }
          this.statusDialogVisible = false
        })
        .catch((error) => {
          console.error('状态更新失败:', error)
          this.$message.error('状态更新失败')
        })
        .finally(() => {
          this.statusLoading = false
        })
    },

    /**
     * 获取合作商列表（用于下拉选择）
     */
    getAppClientList() {
      request({
        url: '/api/backend/app-client/list',
        method: 'get',
        params: { limit: 500 },
      })
        .then((response) => {
          this.appClientList = response.data.data || []
        })
        .catch((error) => {
          console.error('获取合作商列表失败:', error)
        })
    },

    /**
     * 批量导入 - 打开弹窗
     */
    handleBatchImport() {
      this.importDialogVisible = true
    },

    /**
     * 一键生成并绑定手机号
     */
    handleGenerate() {
      this.generateResult = null
      this.generateResultPage = 1
      this.generateDialogVisible = true
      this.$nextTick(() => {
        this.$refs.generateForm && this.$refs.generateForm.clearValidate()
      })
    },

    handleGeneratePrefixInput(value) {
      this.generateForm.phone_prefix = String(value || '')
        .replace(/\D/g, '')
        .slice(0, 10)
      this.generateResult = null
    },

    resetGenerateForm() {
      this.generateLoading = false
      this.generateResult = null
      this.generateResultPage = 1
      this.generateForm = {
        app_client_id: undefined,
        phone_prefix: '',
        quantity: 10,
        phone_type: 2,
        is_enabled: 1,
        remark: '',
      }
      this.$nextTick(() => {
        this.$refs.generateForm && this.$refs.generateForm.clearValidate()
      })
    },

    submitGenerate() {
      this.$refs.generateForm.validate((valid) => {
        if (!valid) return

        const channelName = this.selectedGenerateAppClientName
        this.$confirm(
          `确认生成 ${this.generateForm.quantity} 个手机号并绑定到 ${channelName}？`,
          '生成确认',
          {
            confirmButtonText: '生成并绑定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        )
          .then(() => {
            this.generateLoading = true
            return request({
              url: '/api/backend/phone-account-pool/generate',
              method: 'post',
              data: { ...this.generateForm },
            })
          })
          .then((response) => {
            if (!response) return
            this.generateResult = response.data
            this.generateResultPage = 1
            this.$message.success(
              `成功生成并绑定 ${response.data.generated_count} 个手机号`,
            )
            this.getList()
          })
          .catch((error) => {
            if (error !== 'cancel' && error !== 'close') {
              console.error('一键生成手机号失败:', error)
            }
          })
          .finally(() => {
            this.generateLoading = false
          })
      })
    },

    /**
     * 处理表格选择变化
     */
    handleSelectionChange(val) {
      this.selectedIds = val.map((item) => item.id)
    },

    /**
     * 批量启用
     */
    handleBatchEnable() {
      if (!this.selectedIds.length) return
      this.$confirm('确定启用选中的手机号账号？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.batchLoading = true
          request({
            url: '/api/backend/phone-account-pool/batch-change-status',
            method: 'post',
            data: { ids: this.selectedIds, is_enabled: 1 },
          })
            .then(() => {
              this.$message.success('批量启用成功')
              this.getList()
              this.selectedIds = []
            })
            .catch(() => {
              this.$message.error('批量启用失败')
            })
            .finally(() => {
              this.batchLoading = false
            })
        })
        .catch(() => {})
    },

    /**
     * 批量禁用
     */
    handleBatchDisable() {
      if (!this.selectedIds.length) return
      this.$confirm('确定禁用选中的手机号账号？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.batchLoading = true
          request({
            url: '/api/backend/phone-account-pool/batch-change-status',
            method: 'post',
            data: { ids: this.selectedIds, is_enabled: 0 },
          })
            .then(() => {
              this.$message.success('批量禁用成功')
              this.getList()
              this.selectedIds = []
            })
            .catch(() => {
              this.$message.error('批量禁用失败')
            })
            .finally(() => {
              this.batchLoading = false
            })
        })
        .catch(() => {})
    },

    /**
     * 批量删除
     */
    handleBatchDelete() {
      if (!this.selectedIds.length) return
      const ids = [...this.selectedIds]
      this.$confirm(
        `确定删除选中的 ${ids.length} 个手机号账号？删除后将同时解除渠道绑定。`,
        '批量删除确认',
        {
          confirmButtonText: '确定删除',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(() => {
          this.batchLoading = true
          return request({
            url: '/api/backend/phone-account-pool/batch-delete',
            method: 'post',
            data: { ids },
          })
        })
        .then((response) => {
          if (!response) return
          const deletedCount = response.data && response.data.deleted_count
          this.$message.success(
            `已删除 ${deletedCount || ids.length} 个手机号账号`,
          )
          this.selectedIds = []
          this.getList()
        })
        .catch((error) => {
          if (error !== 'cancel' && error !== 'close') {
            console.error('批量删除手机号账号失败:', error)
          }
        })
        .finally(() => {
          this.batchLoading = false
        })
    },
  },
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 16px;
  padding: 16px 16px 6px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fafbfc;
}
.action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
}
.action-buttons .el-button {
  margin: 0;
}
.action-buttons .el-button + .el-button {
  margin-left: 0;
}
.filter-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.filter-form ::v-deep .el-form-item {
  margin-bottom: 0;
}
.table-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}
.table-toolbar__primary,
.table-toolbar__batch {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.table-toolbar ::v-deep .el-button + .el-button {
  margin-left: 0;
}
.selection-summary {
  margin-right: 4px;
  color: #409eff;
  font-size: 13px;
  white-space: nowrap;
}
.pagination-container {
  margin-top: 20px;
  padding-bottom: 4px;
  overflow-x: auto;
  text-align: right;
}
.detail-content {
  overflow-wrap: anywhere;
}
.assignments-section {
  margin-top: 20px;
}
.assignments-section h4 {
  margin-bottom: 10px;
  font-weight: 500;
}
.delete-tip {
  padding: 10px 0;
}
.delete-tip p {
  margin: 5px 0;
  line-height: 1.8;
}
.delete-tip .warning-text {
  color: #e6a23c;
  font-size: 14px;
}
.status-tip {
  padding: 10px 0;
}
.status-tip p {
  margin: 5px 0;
  line-height: 1.8;
  font-size: 14px;
}
.form-with-gap .el-form-item {
  margin-bottom: 18px;
}
.generate-notice {
  margin-bottom: 20px;
}
.generate-config-card {
  padding: 20px 22px 2px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fafbfc;
}
.generate-section-heading {
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
}
.generate-section-heading__title {
  color: #303133;
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
}
.generate-section-heading__description {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
.generate-form {
  margin-top: 20px;
}
.generate-form ::v-deep .el-form-item {
  margin-bottom: 22px;
}
.generate-form ::v-deep .el-form-item:last-child {
  margin-bottom: 20px;
}
.generate-form ::v-deep .el-form-item__label {
  color: #606266;
  font-weight: 500;
}
.generate-form ::v-deep .el-input-number {
  width: 220px;
}
.generate-form ::v-deep .el-radio {
  margin-right: 32px;
}
.generate-form ::v-deep .el-textarea__inner {
  min-height: 76px !important;
}
.generate-help {
  display: inline-block;
  margin-left: 10px;
  color: #909399;
  font-size: 12px;
  line-height: 20px;
}
.generate-preview,
.generate-result {
  margin-top: 20px;
}
.generate-preview__title {
  margin-bottom: 12px;
  color: #303133;
  font-size: 15px;
  font-weight: 500;
}
.generate-phone-tag {
  margin-top: 2px;
  margin-right: 8px;
  margin-bottom: 2px;
}
.generate-result-table {
  margin-top: 12px;
}
.dialog-pagination {
  margin-top: 14px;
  padding-bottom: 2px;
  overflow-x: auto;
  text-align: right;
}
::v-deep .phone-pool-dialog {
  display: flex;
  flex-direction: column;
  max-width: calc(100vw - 32px);
  max-height: 90vh;
  margin-top: 5vh !important;
}
::v-deep .phone-pool-dialog .el-dialog__header {
  flex: none;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #ebeef5;
}
::v-deep .phone-pool-dialog .el-dialog__body {
  flex: 1;
  min-height: 0;
  padding: 20px 24px;
  overflow-y: auto;
}
::v-deep .phone-pool-dialog .el-dialog__footer {
  flex: none;
  padding: 14px 24px 18px;
  border-top: 1px solid #ebeef5;
}
::v-deep .phone-generate-dialog {
  max-width: calc(100vw - 32px);
}
::v-deep .phone-generate-dialog .el-dialog__body {
  max-height: none;
}
@media (max-width: 768px) {
  .filter-container {
    padding: 12px 12px 2px;
  }
  .filter-form {
    display: block;
  }
  .filter-form ::v-deep .el-form-item {
    display: flex;
    margin-bottom: 12px;
  }
  .filter-form ::v-deep .el-form-item__label {
    width: 88px;
    flex: none;
  }
  .filter-form ::v-deep .el-form-item__content {
    flex: 1;
    margin-left: 0;
  }
  .filter-form ::v-deep .el-input,
  .filter-form ::v-deep .el-select {
    width: 100% !important;
  }
  .table-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .table-toolbar__primary,
  .table-toolbar__batch {
    width: 100%;
  }
  .generate-config-card {
    padding-right: 14px;
    padding-left: 14px;
  }
  .generate-form ::v-deep .el-input-number {
    width: 100%;
  }
  .generate-help {
    margin-top: 6px;
    margin-left: 0;
  }
  ::v-deep .phone-pool-dialog .el-dialog__header,
  ::v-deep .phone-pool-dialog .el-dialog__body,
  ::v-deep .phone-pool-dialog .el-dialog__footer {
    padding-right: 16px;
    padding-left: 16px;
  }
}
</style>
